import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-layout" }
const _hoisted_2 = { class: "h-layout-header" }
const _hoisted_3 = { class: "h-layout-header-right" }
const _hoisted_4 = { class: "tenant" }
const _hoisted_5 = { class: "user" }
const _hoisted_6 = { class: "flex align-items-center cursor-pointer color-primary" }
const _hoisted_7 = { class: "m-r-6" }
const _hoisted_8 = { class: "h-layout-container" }
const _hoisted_9 = { class: "h-layout-container-menu" }
const _hoisted_10 = { class: "h-layout-container-menu_list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "icon" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 0,
  class: "h-layout-container-submenu"
}
const _hoisted_15 = {
  key: 1,
  class: "h-layout-container-router_view"
}

import { ElMessageBox, ElMessage } from 'element-plus'
  import {useSlots, ref, onMounted, onUnmounted} from "vue";
  // import {getrenwumingxilist} from "@/api/doctor";

  import {useRoute, useRouter} from "vue-router";
  import type {Menu} from "./type";
  import MenuCache from "@hview/hview-utils/lib/cache/menu";
  import microApp from '@micro-zoe/micro-app';
  import HMenu from "./h-menu";
  import MicroAppCache, {MicroMessage, MicroMessageType} from "@hview/hview-utils/lib/cache/micro";
  import UserCache from "@hview/hview-utils/lib/cache/user";
  import {userLogoutApi, getliaotianrole} from "./api";
  import MicroUtils from "@hview/hview-utils/lib/tools/micro-utils";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const router = useRouter();
  const route = useRoute();
  const isRouterAlive = ref(true);
  // 菜单列表
  let menuList = ref([]);
  menuList.value = MenuCache.getMenu() || [];
  // 从缓存中获取菜单
 
  const slotDefault = !!useSlots().default;

  const userInfo = UserCache.getUserInfo();
  const teamid = UserCache.getTeam();
  // console.log('teamid-----------------------------************************************',teamid)
  // console.log('userInfo-----------------------------************************************',userInfo)
  const getliaotianroles = (data: any) => {
    getliaotianrole({teamid:teamid,type:'chat'}).then(res=>{
      if(res.data == 1){
        menuList.value.push({id: 7,text: "AI聊天记录",icon: "icon-biaodan",path: "/ai",app: "doctor"})
        menuList.value.push({id: 8,text: "会话记录",icon: "icon-biaodan",path: "/chatDoctor",app: "doctor"})
      }
    })
    getliaotianrole({teamid:teamid,type:'patient'}).then(res=>{
      if(res.data == 2){
        menuList.value.push({id: 9,text: "患者审核",icon: "icon-biaodan",path: "/jsonform",app: "doctor"})
      }
    })
    }
    getliaotianroles()
  // menuList.value.forEach((item,index)=>{
  //   if(userInfo.is_service == 0 && item.text=="消息"){
  //     menuList.value.splice(index, 1);
  //   }
  // })
  // menuList.value.forEach((item,index)=>{
  //   if(userInfo.role != 'admin' && item.text=="表单" ){
      
  //     menuList.value.splice(index, 1);
  //   }
  // })
  // menuList.value.forEach((item,index)=>{
  //   if(userInfo.role != 'admin' && item.text=="文章" ){
  //     menuList.value.splice(index, 1);
  //   }
  // })
  if(teamid == 44 || teamid == 47  || teamid == 56  ){
    menuList.value.push({id: 9,text: "战队用户数据明细",icon: "icon-biaodan",path: "/shujumingxi",app: "doctor"})
    menuList.value.push({id: 10,text: "入组行为明细",icon: "icon-biaodan",path: "/ruzuxingwei",app: "doctor"});
    menuList.value.push({id: 11,text: "任务完成明细",icon: "icon-biaodan",path: "/renwumingxi",app: "doctor"});
  }
  // 
  // 
  // 
  const tenants = UserCache.getTenant();
  const defaultTenants = ref([]);
  defaultTenants.value = UserCache.getDefaultTenant();

  const logout = () => {
    ElMessageBox.confirm(
        '确定退出当前系统吗?',
        '提示',
        {
          type: 'warning'
        }
    ).then(() => {
      // userLogoutApi().then(() => {
        UserCache.clearAll();
        MicroUtils.toLogin();
      // });
    });
  }

  let model = ref({
    tenant: ""
  });


  /**
   * 当前选中的菜单
   */
  let currentMenu: Menu | null = ref(null);

  /**
   * 选中的路径
   */
  let selectPath: string = ref("");

  /**
   * 激活的app
   * @private
   */
  let activeAppId: number = ref(-1);

  /**
   * @description 用户触发下拉
   */
  const userCommandEvent = (data: string) => {
    // console.info(data);
  }

  /**
   * @description 切换租户与社区
   */
  const changeTenants = (data: any) => {
    UserCache.setDefaultTenant(data);
    
    ElMessage.success("切换成功");
    location.reload()
    isRouterAlive.value = false;
    setTimeout(() => {
      isRouterAlive.value = true;
    }, 300);
  }

  /**
   * @description 切换租户
   */
  const commandEvent = (data: any) => {
    if (data.tenant_id == defaultTenants.value.tenant_id) {
      ElMessage.warning(`当前已经是【${data.name}】`);
      return;
    }
    ElMessageBox.confirm(
        `确认切换到【${data.name}】吗?`,
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '暂不切换',
          type: 'warning',
        }
    ).then((res: string) => {
      if (res == "confirm") {
        UserCache.setDefaultTenant(data);
        defaultTenants.value = data;
        if (route.path == "/") {
          // location.reload();
          isRouterAlive.value = false;
          setTimeout(() => {
            isRouterAlive.value = true;
          }, 300);



        } else {
          router.push("/");
        }

      }
    });
  }
  /**
   * @description 获取需要打开的菜单
   */
  const getMenu = (menu: Menu): Menu => {
    // 有子菜单，则直接找子菜单
    if (menu.children && menu.children.length > 0) {
      const menuItem = menu.children[0];
      return getMenu(menuItem);
    } else {
      return menu;
    }
  }

  const menuEvent = (data: Menu) => {
    const menu = getMenu(data);
    // 如果配置了app，代表是加载子系统，否则直接是打开基座系统的页面
    if (menu.app) {
      const microApp = MicroAppCache.getMicroApp() || [];
      // 获取微应用
      const micro = microApp.find((item => item.name == menu.app));
      if (micro) {
        window.history.pushState(null, '', `${micro.baseRoute || micro.path}${menu.path}`);
        // 主动触发一次popstate事件
        window.dispatchEvent(new PopStateEvent('popstate', { state: null }));
        activeAppId.value = data.id;
        currentMenu.value = data;
      } else {
        throw new Error(`未找到微应用配置, appName:【${data.app}】`);
      }
    } else {// 基座系统内跳转
      activeAppId.value = 1;
      router.push(data.path);
    }
  }

  /**
   * @description 微应用全局数据监听
   * @param data
   * @private
   */
  const globalDataListener = (data: MicroMessage) =>{
    // 路由改变触发
    if (data.type == MicroMessageType.ROUTE) {
      microRouteEvent(data.data);
    }
  }

  /**
   * @description 选中父菜单
   * @param data
   * @private
   */
  const selectParentMenu = (matched: any): any => {
    const appName = (route || matched).name || "";
    if (!appName) {
      return false;
    }
    let path = matched.path;
    // 如果子页面指定了选中父菜单，则用指定的菜单进行选中
    if (matched.meta && matched.meta.activeMenu) {
      path = matched.meta.activeMenu;
    }
    if (menuList) {
      const menus = menuList.value.filter(item => item.app == appName);
      const menuApp = getAppMenuByPath(menus, path);
      if (menuApp) {
        currentMenu.value = menuApp;
        activeAppId.value = menuApp.id;
      }
    }
  }

  /**
   * @description 通过path获取菜单
   * @param menuList
   * @param path
   * @private
   */
  const getAppMenuByPath = (menuList: Menu[], path: string): any => {
    for (let i = 0; i < menuList.length; i++) {
      const item = menuList[i];

      if (item.path == path) {
        return item;
      } else if (item.children && item.children.length > 0) {
        const result = getAppMenuByPath(item.children, path);
        if (result) {
          return item;
        }
      }
    }
  }

  /**
   * @description 子应用路由变化触发
   * @param data
   * @private
   */
  const microRouteEvent = (data: any) => {
    // 获取子应用to对象与当前子应用下所有路由表
    const {to, routes} = data;
    if (to && to.meta && to.meta.title) {
      document.title = to.meta.title;
    }
    // 获取matched第一条数据
    const matched = to.matched[0];
    if (!matched) {
      return null;
    }
    // 选中父菜单
    selectParentMenu(matched);
    // 获取当前根path
    const { path } = matched;
    // 获取路由项
    const routeItem = routes.find((item: RouteConfig) => item.path == path);
    const children = routeItem.children || [];
    let selectPathStr = path;
    for (let i = 0; i < children.length; i++) {
      const item = children[i];
      if (item.meta && item.meta.primary) {
        selectPathStr += item.path;
      }
    }
    // 处理选择的path
    selectPathStr = selectPathStr.replace(new RegExp("/$"), "");
    selectPath.value = selectPathStr;
  }

  /**
   * @description 初始化
   * @private
   */
  const init = () => {
    // 没有name的代表是当前项目
    if (route && !route.name && menuList) {
    const {path} = route;
    // 获取portal中的路由
    const portalRoute = menuList.value.filter(item => item.app == "") || [];
    const menu: Menu | null = portalRoute.find(item => item.path == path) || null;
    if (menu) {
      currentMenu.value = menu;
      activeAppId.value = menu.id;
    }
  }

  }

  /**
   * @description mounted
   */
  onMounted(() => {
    init();
    microApp.addGlobalDataListener(globalDataListener);
  });

  /**
   * @description onUnmounted
   */
  onUnmounted(() => {
    microApp.removeGlobalDataListener(globalDataListener)
  })

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "h-layout-header-logo" }, [
        _createElementVNode("img", {
          class: "w-50 m-r-10",
          src: "https://aixin-download.oss-cn-beijing.aliyuncs.com/qianliu-admin/qianliu/logo-2.png"
        })
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "font-size-24" }, " 千流健康管理 ", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h-layout-header-center" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "message" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_cascader, {
            placeholder: "请选择租户和社区",
            modelValue: defaultTenants.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defaultTenants).value = $event)),
            onChange: changeTenants,
            style: {"width":"300px"},
            options: _unref(tenants)
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_dropdown, { onCommand: userCommandEvent }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, {
                    onClick: logout,
                    command: "logout",
                    divided: ""
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "el-icon-switch-button" }, null, -1),
                      _createTextVNode("退出系统")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(userInfo).realname || _unref(userInfo).nickname), 1),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "iconfont icon-yonghu" }, null, -1))
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_scrollbar, { class: "h-layout-container-menu_list__scrollbar" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["menu-item", {active: item.id == _unref(activeAppId)}]),
                    onClick: ($event: any) => (menuEvent(item)),
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["iconfont", item.icon])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.text), 1)
                  ], 10, _hoisted_11))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(currentMenu) && _unref(currentMenu).children && _unref(currentMenu).children.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_unref(HMenu), {
              menuList: _unref(currentMenu).children,
              active: _unref(selectPath)
            }, null, 8, ["menuList", "active"])
          ]))
        : _createCommentVNode("", true),
      (isRouterAlive.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            slotDefault
              ? _renderSlot(_ctx.$slots, "default", { key: 0 })
              : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})